export type ErrorDetails = {
  errorCode?: string;
  errorMessage?: string;
};

const getErrorDetailsFromObject = (error: unknown): ErrorDetails => {
  if (!error || typeof error !== 'object' || Array.isArray(error)) {
    return {};
  }

  const { errorCode, message } = error as { errorCode?: unknown; message?: unknown };
  const normalizedMessage = typeof message === 'string' ? message.trim() : '';

  return {
    errorCode: typeof errorCode === 'string' ? errorCode : undefined,
    errorMessage: normalizedMessage || undefined,
  };
};

export const extractErrorDetails = (error: unknown): ErrorDetails => {
  const details = getErrorDetailsFromObject(error);
  if (details.errorCode || details.errorMessage) return details;

  if (typeof error !== 'string') return {};

  try {
    const parsedError = JSON.parse(error);
    return getErrorDetailsFromObject(parsedError);
  } catch {
    return {};
  }
};
